import {makeAutoObservable} from "mobx";
import {FormActive} from "@/types/login-form-active";


export class LoginStore {
    formActive = FormActive.Login
    constructor() {
        makeAutoObservable(this);
    }
    setFormActive= (formActive: FormActive) => {
        this.formActive = formActive
    }
}
